import React,  {useState , useEffect} from "react";
import { Link   } from "react-router-dom";
import {Links} from 'routes/PathLink';

import {
  useSuperInvestorsQuery
} from '../../data/company';
import Breadcrumb  from "components/Breadcrumb";
import { useInView } from "react-intersection-observer";
import { formatPostTime, APP_URL , APP_NAME , formatToCrN} from "../../components/config/Common";
import { useSiteSettings } from '../../contexts/site-settings/site-settings';
//import "./screens.css";
import Header from "../../layouts/Header";
import Footer from "../../layouts/Footer";
import Seo from 'components/seo/seo'
import {Helmet  } from 'react-helmet-async'

const  SuperInvestorList= () => {
    //console.log('symbol===', tag)
 const [data, setData] = useState([]);
 const [metaTitle, setMetaTitle] = useState(`Indian Popular Investors Portfolio Tracker - Top Investor Holdings - ${APP_NAME} `)
  const [metaDesc, setMetaDesc] = useState('Analyze stock portfolios of leading popular investors. Monitor their holdings, investment trends, and portfolio changes across Indian stock markets.')
 
//const [page, setPage] = useState(1);
//const [loading, setLoading] = useState(false);
//const [hasMore, setHasMore] = useState(true);
const [search, setSearch] = useState("");
const [debouncedSearch, setDebouncedSearch] = useState("");

const { ref, inView } = useInView({
  threshold: 0,
});


useEffect(() => {
  const timer = setTimeout(() => {
    setDebouncedSearch(search);
  }, 400);

  return () => clearTimeout(timer);
}, [search]);

    const { sitelogo } = useSiteSettings();
    const {
        superinvestordata,
        isLoading: loading,
         fetchNextPage,
        hasNextPage,
        isFetchingNextPage,
    } = useSuperInvestorsQuery({
        limit:49,
        search: debouncedSearch, // 🔥 ADD THIS
    });
  

/*
useEffect(() => {
  fetchInvestors(1);
}, []);
*/

useEffect(() => {
  if (inView && hasNextPage && !isFetchingNextPage) {
    fetchNextPage();
  }
}, [inView, hasNextPage,isFetchingNextPage]);

useEffect(() => {
  // Reset scroll trigger when search changes
  window.scrollTo(0, 0);
}, [debouncedSearch]);
/*
const fetchInvestors = async (pageNo) => {
  if (loading || !hasMore) return;

  setLoading(true);

  const res = await fetch(
    `/api/super-investors?page=${pageNo}&limit=9`
  );
  const result = await res.json();

  if (result.data.length === 0) {
    setHasMore(false);
  } else {
    setData(prev => [...prev, ...result.data]);
  }

  setLoading(false);
};
*/


const breadcrumb = [
  {
    name:'Home',
    link:`${process.env.REACT_APP_URL}`,
  },
  {
    name:`Indian Top Investors`,
    link:null
  }
]


  //  console.log("superinvestordata",superinvestordata);
    return(
        <>
          <Helmet>
            </Helmet>
            <Seo 
                title={`${metaTitle}`}
                desc={metaDesc && metaDesc.substring(0, 200)}
                url={`${APP_URL}/indian-top-investors`}
              />
         <Header />
         <div className="space-y-5 px-5">
            <Breadcrumb breadcrumb={breadcrumb} />
            {/*<div className="text-center py-20 bg-white">
              <h1 className="text-4xl font-bold mb-4">Super Investors</h1>

              <p className="text-accent text-xl font-semibold mb-3">
                Coming Soon 🚀
              </p>

              <p className="text-gray-500 max-w-xl mx-auto">
                Soon you will be able to track the portfolios, holdings,
                and stock picks of top investors.
              </p>
            </div>*/}

            <section className="bg-white shadow-sm z-50 rounded-xl p-5">
             
            {!superinvestordata ? 
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">

  {[...Array(12)].map((_, i) => (
    <div
      key={i}
      className="p-3 border border-gray-200 rounded-lg animate-pulse"
    >
      <div className="h-4 bg-gray-200 rounded w-4/5"></div>
    </div>
  ))}

</div>
               
            :
            <>
                <h2 className="text-2xl ">Top Investors</h2>
                <p className="mb-5">Look into the portfolio of these Top Popular Investors to find out their favourite stocks.</p>
                <div className="mb-5">
              <input
                type="text"
                placeholder="Search investor (e.g. Damani)"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                className="w-full md:w-1/3 border border-gray-300 rounded-lg px-4 py-2 focus:outline-none focus:ring-2 focus:ring-accent"
              />

              {search && (
                <button
                  onClick={() => setSearch("")}
                  className="ml-2 text-sm text-red-500"
                >
                  Clear
                </button>
              )}
            </div>
               
                <div className="w-full">{loading ? <section className="bg-white shadow-md p-5">
                  <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">

  {[...Array(12)].map((_, i) => (
    <div
      key={i}
      className="p-3 border border-gray-200 rounded-lg animate-pulse"
    >
      <div className="h-4 bg-gray-200 rounded w-4/5"></div>
    </div>
  ))}

</div>
</section>
                :null
                }
                </div>

                
                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
  {!loading && superinvestordata?.map((val) => (
    
    <Link 
      to={`${Links.INVESTOR}/${val?.slug}`}
      key={val?.share_holder_id}
      className="group bg-white border border-gray-200 rounded-2xl p-5 shadow-sm hover:shadow-xl hover:border-accent transition-all duration-300"
    >
      
      {/* Avatar */}
      <div className="flex items-center gap-4">
       
        <div>
          <h3 className="group bg-white transition">
            {val?.investor_name}
          </h3>
          
        </div>
      </div>
    </Link>

  ))}

  {/* Infinite scroll trigger */}
  <div ref={ref} className="h-1"></div>
</div>
            </>
            }

            {isFetchingNextPage && (
            <div className="text-center py-4 text-gray-500">
                Loading more investors...
            </div>
            )}
            </section> 
        </div>
    <Footer />
    </>
    )

}
export default SuperInvestorList